import { SelectedFile } from "./Models";

export class MailWorkModel {
    title: string | null = null;
    message: string | null = null;
    lstFile: SelectedFile[] | null = null;
}
